import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { DownloadCloud, RefreshCw } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";

const STATUS = { ok: "Completato", running: "In corso...", error: "Errore" };

export function ImportPanel() {
  const [runs, setRuns] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    api.get("/admin/import-runs").then((r) => setRuns(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    if (!runs.some((r) => r.status === "running")) return undefined;
    const t = setTimeout(load, 3000);
    return () => clearTimeout(t);
  }, [runs, load]);
  const run = async (num) => {
    setBusy(true);
    try {
      await api.post("/admin/import-games", { num });
      toast.success("Importazione avviata");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <div className="rounded-xl border border-white/10 bg-[#0d2233] p-5 space-y-4" data-testid="import-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-bold text-white">Nuovi giochi automatici</h2>
          <p className="text-sm text-slate-300">Ogni giorno alle 4:00 vengono importati gli ultimi 100 giochi dal feed GameMonetize (solo quelli non ancora presenti).</p>
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" size="icon" onClick={load} className="text-slate-200 hover:bg-white/10 hover:text-white" data-testid="import-refresh-btn"><RefreshCw size={16} /></Button>
          <Button disabled={busy} onClick={() => run(100)} className="bg-[#fc0] text-[#043856] hover:bg-yellow-300 font-bold" data-testid="import-now-btn"><DownloadCloud size={16} /> Importa ora (100)</Button>
          <Button disabled={busy} onClick={() => run(1000)} variant="outline" className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white" data-testid="import-1000-btn">Ultimi 1000</Button>
        </div>
      </div>
      <div className="divide-y divide-white/5 text-sm">
        {runs.length === 0 && <p className="text-slate-300">Nessuna importazione eseguita finora.</p>}
        {runs.map((r) => (
          <div key={r.run_id} className="flex flex-wrap justify-between gap-2 py-2" data-testid="import-run-row">
            <span className="text-slate-200">{new Date(r.started_at).toLocaleString("it-IT")} · {r.source === "cron" ? "automatica" : "manuale"}</span>
            <span className={r.status === "error" ? "text-red-300" : r.status === "ok" ? "text-emerald-300" : "text-yellow-200"}>
              {STATUS[r.status] || r.status}{r.status !== "running" && ` · ${r.added || 0} nuovi giochi`}{r.error ? ` · ${r.error}` : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
